<template>
    <div class="Map">
        <div class="container">
            <img :src="map"  class="radius-pic mt-3">
        </div>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>

export default {
    name: 'ActivityMap',
    data() {
        return {
            id: this.$route.query.id,
            map: '',
            isLoading: true,
        }
    },
    created() {
        this.setupData();
    },
    methods: {
        setupData: function () {
            this.$http.fetch`GetOinActivityMap${{
                'id': parseInt(this.id),
            }}
            ${json => {
                this.map = json
                this.isLoading = false
            }}`;
        }
    }
}
</script>
<style lang="less" scoped src="../../less/activity.less"/>